<!--

  Implementation

  -in template:
    <router-btn :text="$t('servicesystem.common_objects.appointment.new')"
              :icon="'mdi-content-save'"
              :color="'primary'"
              :disabled="false"
              :outlined="false"
              @Press="action">
    </router-btn>

  -import:
    import RouterBtn from "@/components/Buttons/RouterBtn.vue";

-->

<template>
  <div>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-bind="attrs" v-on="info ? on : null" v-if="!isPadBool" @click="press()"
          class="mx-1 router-btn font-weight-bold" dark :loading="loading" :small="small && !large" :color="outputColor"
          :outlined="outlined" :class="large && !small ? 'px-7 py-7 largetext' : ''">
          <v-icon v-if="icon" :class="text ? (large && !small ? 'pr-7' : 'pr-2') : ''" v-text="icon" :size="size" />
          <p class="mb-0"> {{ text ? text : '' }}</p>
        </v-btn>

        <v-btn v-else v-bind="attrs" v-on="info ? on : null" @click="press()" :color="outputColor" :outlined="outlined"
          dark :loading="loading" :small="!isPhoneBool" :class="!isPhoneBool ? 'mx-1' : ''" fab>
          <v-icon v-if="icon" v-text="icon" :size="size" />
        </v-btn>
      </template>
      <span>{{ info }}</span>
    </v-tooltip>
  </div>
</template>


<script>
export default {
  name: "RouterBtn",
  props: ["text", "icon", "color", "disabled", "outlined", "textbtn", "large", "small", "loading", "info"],

  data() {
    return {};
  },

  methods: {
    press() {
      this.$emit("Press");
    },
  },

  computed: {
    outputColor() {
      if (this.disabled) {
        return "disabled";
      } else if (this.color) {
        return this.color;
      } else {
        return "";
      }
    },
    size() {
      if (this.isPhoneBool) {
        return 27;
      } else if (this.small) {
        return 15;
      } else if (this.large) {
        return 24;
      } else {
        return 17;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.largetext {
  font-size: 20px !important;
}

@media only screen and (max-width: 1400px) and (min-width: 1000px) {
  .router-bt.v-size--small i {
    padding-top: 2px;
    padding-right: 2px !important;
    font-size: 10px !important;
  }

  .router-btn.v-size--small p {
    font-size: 9px !important;
  }
}
</style>
